module.exports = __webpack_public_path__ + "assets/folder-plus-active.4885148f.svg";